/* CUBE STORE - cosa serve, e dove si finisce, uscendo dalle finestre

   FINESTRA "PROCEDI ALL'ACQUISTO"
     AGGIUNGI AL CARRELLO -> serve una modalita' di pagamento

   FINESTRA "PRENOTA"
     PRENOTA -> serve la modalita' dell'ACCONTO

   Da tutti e due i pulsanti si finisce sulla pagina carrello.

   ==========================================================
   1. SENZA DIRE COME SI PAGA NON SI VA AVANTI
   ==========================================================

   Le caselle nell'app non sono obbligatorie, quindi si poteva mandare
   l'ordine senza averne spuntata nessuna: arrivava una richiesta a cui
   mancava l'unica cosa per cui la finestra esiste, e bisognava
   rincorrere il cliente per telefono.

   Ogni finestra chiede la cosa sua:

     acquisto     -> una qualsiasi delle modalita'
     prenotazione -> una modalita' dell'ACCONTO. Il saldo resta
                     libero: si puo' decidere dopo, l'acconto no,
                     perche' e' quello che tiene ferma la bici.

   Qui si guarda solo CHE COSA e' stato spuntato. Che gli importi
   siano scritti bene, stiano sotto il tetto del metodo e coprano il
   prezzo lo controlla cube-importi.js, che ferma il clic prima ancora
   che arrivi un submit: due controlli sulla stessa cosa direbbero
   presto due cose diverse.

   L'elenco dell'acconto si riconosce dal nome del campo, non
   dall'etichetta che si vede: la stessa regola con cui cube-campi.js
   decide che li' si sceglie un metodo solo. Ritoccare l'etichetta in
   amministrazione non rompe niente; cambiare il NOME del campo
   togliendo la parola "acconto" spegne sia questo controllo sia
   quello - ed e' un guasto silenzioso, non un errore visibile.

   L'OBBLIGO NON SI METTE IN MAGICAL. Rendendo obbligatori i campi
   nell'app lo diventerebbero su qualunque strada passi da quel form.
   Si controlla qui, dove si sa da quale finestra si esce.

   SE IL MODULO NON C'E' NON SI CHIEDE NIENTE
   Meglio un ordine senza dichiarazione che una finestra da cui non si
   esce.

   ==========================================================
   2. DA TUTTE E DUE LE FINESTRE SI VA AL CARRELLO
   ==========================================================

   Il tema aggiunge in sottofondo e resta li'. Noi fermiamo il suo
   invio e mandiamo il form per davvero, con return_to a /cart: e'
   Shopify stesso a mettere l'articolo nel carrello e poi portarci
   sulla pagina.

   Chi ha appena compilato un modulo di pagamento ha finito di
   scegliere e vuole chiudere. Restare sulla scheda prodotto, con la
   finestra che si chiude e nient'altro che cambia, sembra che il clic
   non abbia fatto niente.

   PERCHE' L'INVIO VERO E NON UNA CHIAMATA NOSTRA
   Perche' il form, in quel momento, contiene gia' le risposte del
   modulo: Magical le infila fra i campi quando si preme il pulsante.
   Mandandolo intero partono con l'ordine senza che le si debba andare
   a raccogliere a mano - ed e' esattamente l'errore in cui si e' gia'
   inciampato una volta con requestSubmit, ordine giusto e
   dichiarazione di pagamento persa.

   IL FERMO E' IN FASE DI CATTURA E DEVE RESTARCI
   L'ascolto e' su document in cattura, quindi corre prima di quello
   del tema, e stopImmediatePropagation gli toglie il turno. Se un
   domani il tema spostasse il suo ascolto piu' in alto, il suo invio
   in sottofondo tornerebbe a partire E partirebbe anche il nostro:
   l'articolo entrerebbe DUE VOLTE. E' il modo in cui questa cosa si
   rompe, e non si vede guardando la pagina: si vede nel carrello.

   ==========================================================
   3. LA PROPRIETA' FANTASMA
   ==========================================================

   In ogni riga d'ordine arrivava anche "_Form Fields" con dentro uno
   spazio. Non e' un residuo casuale: nel codice di Magical c'e'

     0 < o.length && o.unshift({key: "_Form Fields", value: " "})

   cioe' se c'e' almeno una risposta ne mette una in cima all'elenco,
   come intestazione del blocco. Non contiene niente e nessuno la
   rilegge: e' un'etichetta, e nel pannello ordini di Shopify si vede
   come una voce vuota sopra le risposte vere.

   Si DISATTIVA, non si cancella. Un campo disattivato non viene
   inviato, ma resta dov'e': se l'app dovesse ritrovarlo per una sua
   ragione lo trova, e non le si rompe niente sotto le mani. E' la
   stessa cura che cube-gruppi.js usa sui campi del modulo non in uso.

   SI TOCCA SOLO SE E' VUOTA. Se un domani l'app ci mettesse dentro
   qualcosa di vero - un riepilogo, un identificativo - quel qualcosa
   parte come prima. Qui si toglie di mezzo un'etichetta senza testo,
   non un dato.

   ==========================================================
   4. LA SCORCIATOIA IN CASSA - SPENTA, NON CANCELLATA
   ==========================================================

   Sotto i pulsanti della finestra dell'acquisto c'era un "oppure" e un
   tasto azzurro PAGA AL CHECKOUT, che aggiungeva al carrello e andava
   dritto in cassa senza chiedere nessuna dichiarazione di pagamento.
   Compariva solo sulla pronta consegna, mai sulla prenotazione.

   E' spento dall'11 agosto 2026, e il motivo e' che non serve piu':
   Alberto ha aggiunto "Pago direttamente al chekout" fra le modalita'
   di pagamento del modulo. La stessa scelta adesso e' una riga
   dell'elenco invece che un secondo pulsante, e il piede della
   finestra torna ad avere una strada sola - quantita' e AGGIUNGI AL
   CARRELLO.

   Non e' solo pulizia: due pulsanti che portano a due posti diversi,
   uno sopra l'altro, sono la stessa trappola per cui PRENOTA e il
   pulsante del tema non convivono (vedi cube-azioni.js).

   COSA CAMBIA DAVVERO. Chi vuole pagare in cassa adesso passa dal
   controllo del punto 1: deve spuntare quella voce prima di
   continuare. Prima ne era esente per costruzione, perche' la
   scorciatoia non inviava il form ma aggiungeva con /cart/add.js.
   Quindi la dichiarazione ora arriva anche da chi paga subito - ed e'
   un guadagno, non un effetto collaterale.

   COME SI RIACCENDE: si rimettono le tre righe di avvio in fondo al
   file, quelle commentate. Tutto il resto - costruisci(), vaiInCassa(),
   l'etichetta, il colore in cube-azioni-piede.css - e' rimasto al suo
   posto e riparte da solo.

   ATTENZIONE, se si riaccende: la quantita' va letta dal selettore
   vero, quello dentro il piede della finestra. Darla per scontata a 1
   farebbe partire un ordine diverso da quello che il cliente vede
   scritto davanti a se'. */
(function () {
  var ETICHETTA = 'Paga al checkout';
  var ATTESA = 'Un attimo...';
  var ERRORE = 'Non ha funzionato: riprova, oppure usa il tasto qui sopra.';

  var ACCONTO = /acconto/i;
  var FANTASMA = 'input[name="properties[_Form Fields]"]';

  var CHIESTO = {
    'su-misura': 'Scegli una modalità di pagamento per continuare',
    prenota: "Scegli come vuoi pagare l'acconto per continuare"
  };

  function piede() {
    return document.querySelector('.cube-modale__piede');
  }

  /* quale finestra e' aperta: '' se nessuna */
  function finestra() {
    var m = document.getElementById('cube-modale');
    if (!m || m.hidden) return '';
    return m.dataset.azione || '';
  }

  function pronta() {
    return typeof window.cubeStatoTaglia === 'function' && window.cubeStatoTaglia() === 'pronta';
  }

  function variante() {
    var i = document.querySelector('form.shopify-product-form input[name="id"]');
    return i ? i.value : '';
  }

  function quantita() {
    var p = piede();
    var i = p ? p.querySelector('input[name="quantity"]') : null;
    var n = i ? parseInt(i.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  /* ---------- 1. il controllo ---------- */

  /* l'elenco su cui insistere: per l'acquisto vanno bene tutte le
     caselle del modulo, per la prenotazione solo quelle dell'acconto */
  function daSpuntare(azione) {
    var g = document.querySelector('.cube-gruppo--' + azione);
    if (!g) return null;
    if (azione !== 'prenota') return g;

    var liste = g.querySelectorAll('fieldset[data-field-name]');
    for (var i = 0; i < liste.length; i++) {
      if (ACCONTO.test(liste[i].getAttribute('data-field-name') || '')) return liste[i];
    }
    return null;
  }

  function inRegola(azione) {
    var dove = daSpuntare(azione);
    if (!dove) return true;
    return !!dove.querySelector('input[type="checkbox"]:checked');
  }

  function avviso() {
    var p = piede();
    if (!p) return null;

    var a = p.querySelector('.cube-modale__avviso');
    if (a) return a;

    a = document.createElement('p');
    a.className = 'cube-modale__avviso';
    a.hidden = true;
    a.setAttribute('role', 'status');
    a.setAttribute('aria-live', 'polite');
    p.insertBefore(a, p.firstChild);
    return a;
  }

  function mostraAvviso(azione) {
    var a = avviso();
    if (!a) return;
    a.textContent = CHIESTO[azione] || CHIESTO['su-misura'];
    a.hidden = false;
  }

  function nascondiAvviso() {
    var p = piede();
    var a = p ? p.querySelector('.cube-modale__avviso') : null;
    if (a) a.hidden = true;
  }

  /* appena si spunta quel che serve l'avviso non ha piu' ragione di
     stare li' */
  document.addEventListener('change', function (e) {
    var c = e.target;
    if (!c || c.type !== 'checkbox' || !c.closest) return;
    if (!c.closest('.ma-custom-field-group')) return;

    var azione = finestra();
    if (azione && inRegola(azione)) nascondiAvviso();
  }, true);

  /* ---------- 2. l'invio, il carrello, e la pulizia ---------- */

  /* l'intestazione vuota di Magical: vedi "LA PROPRIETA' FANTASMA" */
  function spegniFantasma(form) {
    form.querySelectorAll(FANTASMA).forEach(function (campo) {
      if (campo.value && campo.value.trim()) return;
      campo.disabled = true;
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form.shopify-product-form')) return;

    var azione = finestra();
    if (!azione) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (!inRegola(azione)) {
      mostraAvviso(azione);
      return;
    }

    nascondiAvviso();
    spegniFantasma(form);

    var dove = form.querySelector('input[name="return_to"]');
    if (!dove) {
      dove = document.createElement('input');
      dove.type = 'hidden';
      dove.name = 'return_to';
      form.appendChild(dove);
    }
    dove.value = '/cart';

    form.submit();
  }, true);

  /* ---------- 3. la scorciatoia in cassa (spenta) ---------- */

  function vaiInCassa(tasto) {
    var id = variante();
    if (!id) return;

    tasto.disabled = true;
    tasto.textContent = ATTESA;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantita() })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('carrello');
        window.location.href = '/checkout';
      })
      .catch(function () {
        tasto.disabled = false;
        tasto.textContent = ETICHETTA;
        var e = tasto.parentElement.querySelector('.cube-checkout__errore');
        if (!e) {
          e = document.createElement('p');
          e.className = 'cube-checkout__errore';
          e.setAttribute('role', 'status');
          tasto.insertAdjacentElement('afterend', e);
        }
        e.textContent = ERRORE;
      });
  }

  function costruisci() {
    var p = piede();
    if (!p) return;

    var blocco = p.querySelector('.cube-checkout');
    var serve = pronta();

    if (!serve) {
      if (blocco) blocco.remove();
      return;
    }
    if (blocco) return;

    blocco = document.createElement('div');
    blocco.className = 'cube-checkout';

    var oppure = document.createElement('p');
    oppure.className = 'cube-checkout__oppure';
    oppure.textContent = 'oppure';

    var tasto = document.createElement('button');
    tasto.type = 'button';
    tasto.className = 'cube-checkout__tasto';
    tasto.textContent = ETICHETTA;
    tasto.addEventListener('click', function (ev) {
      ev.preventDefault();
      vaiInCassa(tasto);
    });

    blocco.appendChild(oppure);
    blocco.appendChild(tasto);
    p.appendChild(blocco);
  }

  var inCoda = false;
  function programma() {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      costruisci();
    });
  }

  function init() {
    costruisci();
    if (!document.body) return;
    new MutationObserver(programma).observe(document.body, { childList: true, subtree: true });
  }

  /* SPENTO, NON CANCELLATO - vedi il punto 4 in testa al file. I punti
     1, 2 e 3 non passano da qui: i loro ascoltatori sono gia' attivi
     qui sopra, a livello di modulo. Spegnere l'avvio spegne SOLO la
     scorciatoia in cassa. Per riaccenderla si tolgono i commenti alle
     righe qui sotto, e basta quelle.

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  */
})();
